import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const CreateServiceRequest = lazy(() => import('@pages/CreateServiceRequest'));
const ServiceRequestsListPage = lazy(() => import('@pages/serviceRequests/ServiceRequestsListPage'));
const CreateArrangementPage = lazy(() => import('@pages/serviceRequests/CreateArrangementPage'));
const EditServiceRequestArrangementPage = lazy(
  () => import('@pages/serviceRequests/EditServiceRequestArrangementPage')
);

// Route Components
const ServiceRequestsPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-requests-page-title-create')}>
        <CreateServiceRequest />
      </PageWrapper>
    </Suspense>
  );
};

/**
 * The lines-based authoring screen. Additional to `ServiceRequestsPage` above, which
 * keeps the single-recurrence flow operators use today.
 */
const ServiceRequestArrangementPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-requests-page-title-arrangement')}>
        <CreateArrangementPage />
      </PageWrapper>
    </Suspense>
  );
};

const ServiceRequestsTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-requests-page-title-management')}>
        <ServiceRequestsListPage />
      </PageWrapper>
    </Suspense>
  );
};

/** Editing one existing request's lines. Routed under the management list, like `EDIT_VISIT`. */
const ServiceRequestArrangementEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-requests-lines-edit-page-title')}>
        <EditServiceRequestArrangementPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  ServiceRequestsPage,
  ServiceRequestArrangementPage,
  ServiceRequestsTablePage,
  ServiceRequestArrangementEditPage,
};
